import { createContext, useContext } from 'react'

interface ModulesContextValue {
  enabledModules: Record<string, boolean>
  modulesLoaded: boolean
  setEnabledModules: (modules: Record<string, boolean>) => void
  disableModule: (name: string) => void
}

export const ModulesContext = createContext<ModulesContextValue>({
  enabledModules: {},
  modulesLoaded: false,
  setEnabledModules: () => {},
  disableModule: () => {},
})

export function useModules() {
  return useContext(ModulesContext)
}
